<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-card flat>
          <v-tabs
            v-model="tabdata"
            centered>
            <v-tab class="text-capitalize text-left" href="#deskripsi">
              <v-icon left>
                mdi-track-light
              </v-icon>
              Tracer Study
            </v-tab>
            <v-tab class="text-capitalize text-left" href="#linkform">
              <v-icon left>
                mdi-link
              </v-icon>
              Link Form Tracer Study
            </v-tab>
            <v-tab class="text-capitalize text-left" href="#hasil">
              <v-icon left>
                mdi-chart-box
              </v-icon>
              Hasil Tracer Study
            </v-tab>
            <v-tab-item value="deskripsi">
              <v-card flat>
                <v-card-text class="text-justify">
                  <p>
                    Tracer study dilakukan untuk menjaring informasi alumni untuk evaluasi pembelajaran di Politeknik, termasuk evaluasi materi perkuliahan agar dapat mengikuti perkembangan jaman. Tracer study ini menggunakan Googleform yang dibagikan ke seluruh alumni PNB dalam rentang 3 tahun terakhir atau tamat pada tahun 2018, 2019 dan 2020. Rencana semula adalah menggunakan form terpisah untuk setiap jurusan dengan mengambil 1 orang yang bertanggungjawab terhadap Tracer study ini. Namun setelah berjalan sekitar satu bulan, belum diperoleh data yang memadai. Selanjutnya setelah memperoleh masukan melalui program workshop SOP Career Center baik dengan Sekolah Vokasi UGM maupun dengan Universitas Atmajaya Yogyakarta yang telah berpengalaman menyelenggarakan tracer study dengan hasil diatas 90%, maka strategi pelaksanaan diubah.
                  </p>
                  <h3><b>Strategi Baru</b></h3>
                  <p>
                    Di awal Desember, dibuat satu Form baru terpusat untuk seluruh jurusan di Politeknik melalui Googleform yang selanjutnya dilakukan blast sms untuk tamatan 2020, 2019, dan 2018 melalui sms masking. Seluruh Dosen diminta membagi tautan tracer study ke mantan mahasiswa bimbingan mereka yang nomor teleponnya masih dimiliki. Di sosmed juga diminta untuk membagi tautan tracer study.  Enam orang enumerator dari kalangan mahasiswa tiap jurusan ditugaskan untuk memantau dan sebagai reminder. Strategi pelakwsanaan kegiatan Tarcer Study ini digambarkan dalam Gambar dibawah ini.
                  </p>
                  <v-img
                    class="mx-auto mb-5"
                    :src="require('../assets/strategy-tracer.jpg')"
                    alt="Strategi baru tracer study"
                    max-width="700">
                  </v-img>
                  <p>
                    Untuk pertanyaan yang diajukan dalam kuisioner ini, sebagian dapat dilihat pada link berikut: <a @click="tabdata = 'linkform'">Form Tracer Study</a>
                  </p>
                  <p>
                    Hasil yang diperloleh dapat dilihat pada link berikut: <a @click="tabdata = 'hasil'">Hasil Tracer Study</a>
                  </p>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="linkform">
              <v-card flat>
                <v-card-text>
                  Link Form Tracer Study:
                  <a
                    :href="'https://bit.ly/tracerPNB20'"
                    target="_blank">
                    Link
                  </a>
                  <div class="mt-2">
                    <iframe
                      :src="'https://bit.ly/tracerPNB20'"
                      style="width:100%; height:700px;"
                      frameborder="0">
                    </iframe>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="hasil">
              <v-card flat>
                <v-card-text>
                  Link Hasil Tracer Study:
                  <a
                    :href="'/img/tracer-2020.pdf'"
                    target="_blank">
                    Link
                  </a>
                  <div class="mt-2">
                    <object
                      :data="'/img/tracer-2020.pdf'"
                      type="application/pdf"
                      class="pdf-embed-custom"
                      width="100%"
                      height="700px">
                      <p>
                        Web browser anda tidak memiliki PDF plugin.<br>
                        Sebaliknya anda dapat download buku panduan pada tautan berikut:<br>
                        <a target="_blank" :href="'/img/tracer-2020.pdf '">
                          Download
                        </a>
                      </p>
                    </object>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Tracerstudy',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    // this.getJeniskerja();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getJeniskerja() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
